module.exports = __webpack_public_path__ + "static/img/home-service2.a600d029.png";